import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAIInferenceStreamMetadataVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type GetAIInferenceStreamMetadata = {
  aiInferenceStream: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'canEdit' | 'pinned' | 'private' | 'saved' | 'createdAt'
  > & {
    createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
    usage?: Types.Maybe<
      Pick<
        Types.AIInferenceStreamUsage,
        | 'cacheCreationInputTokens'
        | 'cacheReadInputTokens'
        | 'inputTokens'
        | 'modelID'
        | 'outputTokens'
      >
    >;
  };
};

export const GetAIInferenceStreamMetadataDocument = gql`
  query GetAIInferenceStreamMetadata($id: String!) {
    aiInferenceStream(streamId: $id) {
      streamName
      streamId
      canEdit
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      usage {
        cacheCreationInputTokens
        cacheReadInputTokens
        inputTokens
        modelID
        outputTokens
      }
    }
  }
  ${ActorTeaser}
`;

/**
 * __useGetAIInferenceStreamMetadata__
 *
 * To run a query within a React component, call `useGetAIInferenceStreamMetadata` and pass it any options that fit your needs.
 * When your component renders, `useGetAIInferenceStreamMetadata` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAIInferenceStreamMetadata({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAIInferenceStreamMetadata(
  baseOptions: Apollo.QueryHookOptions<
    GetAIInferenceStreamMetadata,
    GetAIInferenceStreamMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAIInferenceStreamMetadata, GetAIInferenceStreamMetadataVariables>(
    GetAIInferenceStreamMetadataDocument,
    options,
  );
}
export function useGetAIInferenceStreamMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAIInferenceStreamMetadata,
    GetAIInferenceStreamMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAIInferenceStreamMetadata, GetAIInferenceStreamMetadataVariables>(
    GetAIInferenceStreamMetadataDocument,
    options,
  );
}
export function useGetAIInferenceStreamMetadataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAIInferenceStreamMetadata,
    GetAIInferenceStreamMetadataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAIInferenceStreamMetadata,
    GetAIInferenceStreamMetadataVariables
  >(GetAIInferenceStreamMetadataDocument, options);
}
export type GetAIInferenceStreamMetadataHookResult = ReturnType<
  typeof useGetAIInferenceStreamMetadata
>;
export type GetAIInferenceStreamMetadataLazyQueryHookResult = ReturnType<
  typeof useGetAIInferenceStreamMetadataLazyQuery
>;
export type GetAIInferenceStreamMetadataSuspenseQueryHookResult = ReturnType<
  typeof useGetAIInferenceStreamMetadataSuspenseQuery
>;
export type GetAIInferenceStreamMetadataQueryResult = Apollo.QueryResult<
  GetAIInferenceStreamMetadata,
  GetAIInferenceStreamMetadataVariables
>;
export function mockGetAIInferenceStreamMetadata({
  data,
  variables,
  errors,
}: {
  data: GetAIInferenceStreamMetadata;
  variables?: GetAIInferenceStreamMetadataVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetAIInferenceStreamMetadataDocument, variables },
    result: { data, errors },
  };
}
